module.exports = __webpack_public_path__ + "img/Flag_of_Bahrain (1).30728ffe.svg";